/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
import React from 'react';

import {
  TableContainer,
  Table,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  Paper,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { numGradeToEUgrade } from '../../../helpers/utils';

const useStyles = makeStyles({
  root: {
    marginTop: '30px',
    marginBottom: '30px',
  },
  table: {
    width: '100%',
    minWidth: 650,
    '& .MuiTableCell-root': {
      borderLeft: '1px solid rgba(224, 224, 224, 1)',
    },
  },
  empty: {
    backgroundColor: '#f3f2f2',
  },
  caption: {
    paddingLeft: '15px',
  },
});

const StudentScores = ({ students }) => {
  const classes = useStyles();

  return (
    <TableContainer component={Paper} className={classes.root}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Nom de famille</TableCell>
            <TableCell align="center">Prénom</TableCell>
            <TableCell align="center" colSpan={2}>Expression orale</TableCell>
            <TableCell align="center">Compréhension orale</TableCell>
            <TableCell align="center">Expression écrite</TableCell>
            <TableCell align="center">Compréhension écrite</TableCell>
            <TableCell align="center" colSpan={2}>Niveau global</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell align="center" colSpan={2}> </TableCell>
            <TableCell align="center">Fluidité</TableCell>
            <TableCell align="center">Précision</TableCell>
            <TableCell align="center"> </TableCell>
            <TableCell align="center" colSpan={2}>Test en ligne pour nouveaux participants</TableCell>
            <TableCell align="center">EW</TableCell>
            <TableCell align="center">CEFR*</TableCell>
          </TableRow>
          {students.map((student) => (
            <TableRow>
              <TableCell align="center">{student.name}</TableCell>
              <TableCell align="center">{student.firstname}</TableCell>
              <TableCell align="center">{student.test?.oralFluency || ''}</TableCell>
              <TableCell align="center">{student.test?.oralAccuracy || ''}</TableCell>
              <TableCell align="center">{student.test?.listeningComprehension || ''}</TableCell>
              <TableCell align="center">{student.test?.writing || ''}</TableCell>
              <TableCell align="center">{student.test?.readingComprehension || ''}</TableCell>
              <TableCell align="center">{student.test?.global || ''}</TableCell>
              <TableCell align="center">{numGradeToEUgrade(student.test?.global || 0)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Typography className={classes.caption} variant="caption">(*) Cadre européen commun de référence pour les langues (CECR)</Typography>
    </TableContainer>
  );
};

export default StudentScores;
